import { useEffect, useState } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { LangContext } from "@/i18n";
import Landing from "@/pages/Landing";
import Shop from "@/pages/Shop";
import ShopSuccess from "@/pages/ShopSuccess";

function App() {
  const [lang, setLang] = useState("fr");

  useEffect(() => {
    const handler = (e) => setLang(e.detail);
    window.addEventListener("set-lang", handler);
    return () => window.removeEventListener("set-lang", handler);
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  return (
    <LangContext.Provider value={lang}>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/shop" element={<Shop />} />
          <Route path="/shop/success" element={<ShopSuccess />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </LangContext.Provider>
  );
}

export default App;
